export default "__VITE_ASSET__4t7RB6mc__"